import axios from 'axios';
import api_url from '../urls';

const actions = {

    addDatamateria (context, value) {

//console.log(value.oferta_grade_empresa.id)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.post(api_url.api_admin.concat('v1/admin/data_gravar_dados'),
        {
            nome:'dados',
            oferta_disciplina_grade_id: value.oferta_disciplina_grade.id,
            oferta_grade_empresa_id: value.oferta_grade_empresa.id,
            data_abertura: value.data_abertura,
            data_encerramento: value.data_encerramento,
            empresa_id: 1,
            status: 1

        }
        , {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             console.log(response);
        })
        .catch((error) => {
            console.log(error.response);
        });
        
    },
    allDatamateria (context, valor) {
      console.log(valor)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/data_disciplina-mate/'+valor,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
           //  console.log(response);
            context.commit('GET_DATA_MATERIA', response.data)
        })
        .catch((error) => {
            console.log(error);
        });
        
    },
    allMateriaCurso (context, valor) {

        
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin+'v1/admin/data-disciplinas-disci/'+ valor,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
         console.log(response);
            context.commit('GET_MATERIAS_CURSO', response.data)
        })
        .catch((error) => {
            console.log(error);
        });
        
    },
   async setMateria (context, value) {
       
       await context.commit('SET_MATERIA', value)
       
      },

     async salvarEditarMateria (context, value) {
            //console.log(value)
        context.commit('PRELOADER_MUDAR',true)
                const USER_TOKEN = localStorage.getItem('access_token');
                const AuthStr = 'Bearer '.concat(USER_TOKEN)
             await  axios.post(api_url.api_admin.concat('v1/admin/salvarEditarMateria'),
                {
                    id: value.id,
                    funcionario_id: value.funcionario_id
        
                }
                , {
                    headers: {
                        'Authorization': AuthStr,
                        'Content-Type': 'application/json',
                        'X-Requested-With':'XMLHttpRequest',
                    }
                })
                .then(response => {
                     console.log(response);
                })
                .catch((error) => {
                    console.log(error.response);
                }).finally(()=> context.commit('PRELOADER_MUDAR',false))
                
            },
}

export default actions